import React, { useState, useEffect } from "react";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { API_BASE } from "../../utils/api";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../Product/Price.css";
import { formatCurrency } from "../../utils/currency";
const OrderDetails = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [statusHistory, setStatusHistory] = useState([]);
  const [address, setAddress] = useState("");
  const [showAddRow, setShowAddRow] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [driverName, setDriverName] = useState("");
  const [driverMobile, setDriverMobile] = useState("");
  const [driverList, setDriverList] = useState([]);
  const [useNewDriver, setUseNewDriver] = useState(false);
  const [driverId, setDriverId] = useState("");
  const [rows, setRows] = useState(selectedOrder?.products || []);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/orders/drivers`);
        setDriverList(response.data);
      } catch (error) {
        console.error("Driver fetch error:", error);
      }
    };

    fetchDrivers();
  }, []);

  useEffect(() => {
    if (selectedOrder) {
      fetchStatusHistory(selectedOrder._id);
      setAddress(selectedOrder.address || "");
    }
  }, [selectedOrder]);
  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };
  const [selectedSort, setSelectedSort] = useState("");
  const statusBlockStyle = (status) => ({
    padding: "10px 20px",
    backgroundColor: selectedSort === status ? "#f9d59b" : "#c484f3",
    color: selectedSort === status ? "white" : "white",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    height: "80px",
    width: "160px",
    transition: "background-color 0.3s",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  });

  const fetchStatusHistory = async (orderId) => {
    try {
      const response = await axios.get(
        `${API_BASE}/api/orders/statusHistory/${orderId}`
      );
      setStatusHistory(response.data);
    } catch (error) {
      console.error("Error fetching status history:", error);
    }
  };
  const statusList = ["placed", "accepted", "dispatched", "delivered"];
  const currentStatusIndex = statusList.findIndex(
    (s) => s === orders.currentStatus
  );

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/orders/all`);
      setOrders(response.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };
  const statusFlow = {
    pending: ["accept", "reject"],
    accept: ["ready for delivery"],
    "ready for delivery": ["delivery pickup"],
    "delivery pickup": ["out for delivery"],
    "out for delivery": ["completed"],
    completed: [],
  };

  const getCountByStatus = (status) => {
    return orders.filter((order) => order.status === status).length;
  };

  /*const statusOrder = ["pending", "accept", "ready for delivery", "delivery pickup", "reject"];*/

  const statusPriority = [
    "pending",
    "accept",
    "ready for delivery",
    "delivery pickup",
    "out for delivery",
    "completed",
  ];

  useEffect(() => {
    if (selectedOrder && selectedOrder.products) {
      setRows(selectedOrder.products);
    }
  }, [selectedOrder]);
  const filteredOrders = orders.filter((order) => {
    const matchesSearch =
      order.orderId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.phoneNumber.includes(searchTerm) ||
      order.status.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      !selectedSort ||
      order.status.toLowerCase() === selectedSort.toLowerCase();

    return matchesSearch && matchesStatus;
  });

  const sortedOrders = [...filteredOrders].sort(
    (a, b) =>
      statusPriority.indexOf(a.status.toLowerCase()) -
      statusPriority.indexOf(b.status.toLowerCase())
  );

  const getNextStatuses = (currentStatus) => statusFlow[currentStatus] || [];

  const updateOrderStatus = async () => {
    if (!selectedOrder) return;

    if (
      (newStatus || selectedOrder.status) === "accept" &&
      (!address || address.trim() === "")
    ) {
      toast.error("Cannot accept order without an address.");
      return;
    }

    try {
      let finalDriverId = driverId;

      if ((newStatus || selectedOrder.status) === "delivery pickup") {
        if (!finalDriverId && (!driverName.trim() || !driverMobile.trim())) {
          toast.error("Please enter driver name and mobile number.");
          return;
        }

        if (!finalDriverId && driverName.trim() && driverMobile.trim()) {
          const driverRes = await axios.post(`${API_BASE}/api/orders/add`, {
            name: driverName.trim(),
            mobileNumber: driverMobile.trim(),
            isActive: true,
          });
          finalDriverId = driverRes.data._id;
        }
      }

      await axios.put(
        `${API_BASE}/api/orders/updateStatus/${selectedOrder.orderId}`,
        {
          status: newStatus,
          assignedDriver: finalDriverId || null,
        }
      );

      toast.success("Order status updated successfully!");
      fetchOrders();
      setSelectedOrder(null);
    } catch (error) {
      console.error("Error updating order status:", error);
      toast.error("Failed to update order status.");
    }
  };

  const getProductPrice = (product) => {
    if (product.offerPrice != null && product.offerPrice > 0) {
      return product.offerPrice;
    }

    if (product.price != null && product.price > 0) {
      return product.price;
    }

    if (product.variants && product.variants.length > 0) {
      const variant = product.variants[0];
      if (variant.offerPrice != null && variant.offerPrice > 0) {
        return variant.offerPrice;
      }
      return variant.price || 0;
    }

    return 0;
  };

  const handleAddProduct = async () => {
    if (!selectedProduct || quantity < 1) {
      toast.error("Please select a product and enter a valid quantity.");
      return;
    }

    const newProduct = {
      _id: selectedProduct._id,
      productTitle: selectedProduct.productName,
      quantity,
      price: getProductPrice(selectedProduct),
    };

    setSelectedOrder((prevOrder) => ({
      ...prevOrder,
      products: [...prevOrder.products, newProduct],
    }));

    await axios.put(`${API_BASE}/api/orders/updateOrder/${selectedOrder._id}`, {
      products: [...selectedOrder.products, newProduct],
    });

    setSelectedProductId("");
    setSelectedProduct(null);
    setQuantity(1);
    setShowAddRow(false);
    toast.success("Product added to the order!");
  };

  const handleAddRow = () => {
    setRows((prev) => [
      ...prev,
      {
        _id: Date.now(),
        productTitle: "",
        quantity: "",
        price: "",
        isNew: true,
      },
    ]);
    setShowSubmitButton(true);
  };

  const handleChange = async (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    // Recalculate subtotal if quantity or price changes
    const quantity = parseInt(updated[index].quantity);
    const price = parseFloat(updated[index].price);

    if (!isNaN(quantity) && !isNaN(price)) {
      updated[index].subtotal = quantity * price;
    } else {
      updated[index].subtotal = 0;
    }

    setRows(updated);

    if (field === "productTitle" && value.length > 2) {
      try {
        const res = await axios.get(
          `${API_BASE}/api/products/search?query=${value}`
        );
        setSuggestions(res.data);
      } catch (err) {
        console.error("Error fetching suggestions", err);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSelectSuggestion = (index, product) => {
    const updated = [...rows];
    const price = getProductPrice(product);
    const quantity = parseInt(updated[index].quantity) || 0;

    updated[index].productTitle = product.productName;
    updated[index].price = price;
    updated[index].productId = product._id;
    updated[index].subtotal = quantity * price;

    setRows(updated);
    setSuggestions([]);
  };

  const handleSubmit = async () => {
    const newItems = rows.filter((row) => row.isNew);

    const cleanedItems = [];
    for (const item of newItems) {
      if (!item.productId) {
        toast.error(
          `Product "${item.productTitle}" is not selected from suggestions. Please select a valid product.`
        );
        return;
      }

      if (
        !item.quantity ||
        isNaN(item.quantity) ||
        parseInt(item.quantity) <= 0
      ) {
        toast.error(
          `Please enter a valid quantity for "${item.productTitle}".`
        );
        return;
      }

      cleanedItems.push({
        productId: item.productId,
        productTitle: item.productTitle,
        quantity: parseInt(item.quantity),
        price: parseFloat(item.price),
        orderStatus: item.orderStatus || "",
        isAdmin: true,
      });
    }

    if (cleanedItems.length === 0) {
      toast.info("No new items to add.");
      setShowSubmitButton(false);
      return;
    }

    try {
      const response = await axios.put(
        `${API_BASE}/api/orders/${selectedOrder.orderId}/admin-update`,

        { updatedProducts: cleanedItems }
      );

      toast.success("Order updated successfully");
      setShowSubmitButton(false);
      fetchOrders();
      setSelectedOrder((prev) => ({
        ...prev,
        products: [
          ...(prev.products || []),
          ...cleanedItems.map((item) => ({
            _id: item.productId,
            productTitle: item.productTitle,
            quantity: item.quantity,
            price: item.price,
            active: true,
          })),
        ],
      }));
    } catch (error) {
      console.error("Error during submit:", error);
      toast.error("Failed to update order. Please try again.");
    }
  };
  const orderIdTemplate = (rowData) => {
    const createdTime = new Date(rowData.createdAt);
    const now = new Date();
    const diffMinutes = (now - createdTime) / (1000 * 60);
    const showWarning = rowData.status !== "completed" && diffMinutes > 30;

    return (
      <>
        {rowData.orderId}
        {showWarning && (
          <span style={{ color: "red", marginLeft: "10px", fontWeight: "bold" }}>
            ⚠
          </span>
        )}
      </>
    );
  };

  // Products column
  const productsTemplate = (rowData) => {
    if (!rowData.products || rowData.products.length === 0) return "No products";

    return (
      <div style={{ whiteSpace: "pre-wrap" }}>
        {rowData.products.map((p, index) => (
          <div key={index} style={{ marginBottom: "4px" }}>
            • {p.productTitle.split(",")[0]} ({p.quantity})
          </div>
        ))}
      </div>
    );
  };


  // Driver column
  const driverTemplate = (rowData) => {
    return rowData.assignedDriver?.name ? (
      <span>{rowData.assignedDriver.name}</span>
    ) : (
      <span style={{ color: "#888" }}>—</span>
    );
  };

  const responsiveColumnHeader = (header, field, customBody) => (rowData) => (
    <div className="responsive-cell">
      <span className="responsive-header">{header}</span>
      <span className="responsive-value">
        {customBody ? customBody(rowData) : rowData[field]}
      </span>
    </div>
  );



  return (
    <div style={{ fontFamily: "Roboto" }}>
      <ToastContainer position="top-center" autoClose={3000} />
      {selectedOrder ? (
        <div style={{ padding: "20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton
              onClick={() => setSelectedOrder(null)}
              className="back-button"
              style={{
                backgroundColor: "#e0e0e0",
                border: "1px solid #ccc",
                borderRadius: "50%",
                padding: "5px",
                color: "#333",
              }}
            >
              <KeyboardBackspaceIcon fontSize="medium" />
            </IconButton>
            <h5 className="heading">Order Details</h5>
          </div>

          <p>
            <strong>Order ID:</strong> {selectedOrder.orderId}
          </p>
          <p>
            <strong>Phone Number:</strong> {selectedOrder.phoneNumber}
          </p>

          <p>
            <strong>Address:</strong>{" "}
            {selectedOrder.address ? selectedOrder.address : <span style={{ color: "#888" }}>No address</span>}
          </p>
          {selectedOrder.pincode && (
            <p>
              <strong>Pincode:</strong> {selectedOrder.pincode}
            </p>
          )}


          <div
            style={{
              maxHeight: "55vh",
              overflowY: "auto",
              padding: "20px",
              scrollbarWidth: "none",
            }}
          >
            <table
              style={{
                width: "50%",
                borderCollapse: "collapse",
                overflow: "auto",
                backgroundColor: "white",
                padding: "20px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                    Product
                  </th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                    Quantity
                  </th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                    Price
                  </th>
                  <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                    Sub Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((product, index) => (
                  <tr key={product._id}>
                    <td
                      style={{
                        padding: "8px",
                        border: "1px solid #ddd",
                        position: "relative",
                      }}
                    >
                      {product.isNew ? (
                        <>
                          <input
                            type="text"
                            value={product.productTitle}
                            onChange={(e) => {
                              console.log("Input changed:", e.target.value);
                              handleChange(
                                index,
                                "productTitle",
                                e.target.value
                              );
                            }}
                            autoComplete="off"
                          />
                          {index === rows.length - 1 &&
                            suggestions.length > 0 && (
                              <ul
                                style={{
                                  listStyle: "none",
                                  margin: 0,
                                  padding: "5px",
                                  border: "1px solid #ccc",
                                  backgroundColor: "white",
                                  position: "absolute",
                                  width: "100%",
                                  zIndex: 10,
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                }}
                              >
                                {suggestions.map((item) => (
                                  <li
                                    key={item._id}
                                    onClick={() =>
                                      handleSelectSuggestion(index, item)
                                    }
                                    style={{
                                      padding: "5px",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {item.productName}
                                  </li>
                                ))}
                              </ul>
                            )}
                        </>
                      ) : (
                        product.productTitle.split(",")[0]
                      )}
                    </td>

                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                      {product.isNew ? (
                        <input
                          type="number"
                          value={product.quantity}
                          onChange={(e) =>
                            handleChange(index, "quantity", e.target.value)
                          }
                        />
                      ) : (
                        product.quantity
                      )}
                    </td>
                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                      {product.isNew ? (
                        <input
                          type="number"
                          value={product.price}
                          onChange={(e) =>
                            handleChange(index, "price", e.target.value)
                          }
                        />
                      ) : (
                        formatCurrency(product.price)
                      )}
                    </td>
                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                      {product.quantity && product.price
                        ? formatCurrency(parseFloat(product.quantity) * parseFloat(product.price))
                        : formatCurrency(0)}
                    </td>

                    {/*<td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>
  <span
    style={{ cursor: "pointer", color: "red", fontWeight: "bold" }}
    onClick={() => {
      setDeleteIndex(index);
      setShowDeletePopup(true);
    }}
    title="Delete Item"
  >
    ❌
  </span>
</td>*/}
                  </tr>
                ))}
                <tr>
                  <td
                    colSpan="3"
                    style={{ textAlign: "center", padding: "10px" }}
                  >
                    <span
                      onClick={handleAddRow}
                      style={{
                        fontSize: "14px",
                        cursor: "pointer",
                        color: "#007bff",
                        userSelect: "none",
                      }}
                    >
                      ➕ Add Item
                    </span>
                  </td>
                </tr>
                {showSubmitButton && (
                  <tr>
                    <td
                      colSpan="3"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      <button
                        onClick={handleSubmit}
                        style={{
                          padding: "8px 16px",
                          fontSize: "16px",
                          backgroundColor: "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Submit
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {showDeletePopup && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 999,
                }}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                    width: "300px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ marginBottom: "20px" }}>
                    Are you sure you want to delete this order item?
                  </p>
                  <button
                    onClick={async () => {
                      const item = rows[deleteIndex];
                      try {
                        const res = await fetch(
                          `${API_BASE}/api/orders/items/${item._id}`,
                          {
                            method: "DELETE",
                          }
                        );

                        if (res.ok) {
                          const updatedRows = [...rows];
                          updatedRows.splice(deleteIndex, 1);
                          setRows(updatedRows);
                          setShowDeletePopup(false);
                        } else {
                          console.error("Failed to delete");
                        }
                      } catch (err) {
                        console.error("Error deleting item:", err);
                      }
                    }}
                    style={{
                      marginRight: "10px",
                      backgroundColor: "#dc3545",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Yes, Delete
                  </button>

                  <button
                    onClick={() => setShowDeletePopup(false)}
                    style={{
                      backgroundColor: "#6c757d",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <label
              style={{
                display: "block",
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              <strong>Update Status:</strong>
            </label>
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <select
                value={newStatus || selectedOrder.status}
                onChange={(e) => setNewStatus(e.target.value)}
                disabled={selectedOrder.status === "completed"}
                style={{ width: "30%", height: "30px" }}
              >
                <option value={selectedOrder.status} disabled>
                  {selectedOrder.status.charAt(0).toUpperCase() +
                    selectedOrder.status.slice(1)}
                </option>
                {getNextStatuses(selectedOrder.status).map((status) => (
                  <option key={status} value={status}>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </option>
                ))}
              </select>
              {newStatus === "delivery pickup" &&
                selectedOrder.status !== "delivery pickup" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    {!useNewDriver ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <select
                          value={driverId}
                          onChange={(e) => setDriverId(e.target.value)}
                          style={{ padding: "5px", width: "40%" }}
                        >
                          <option value="">Select Driver</option>
                          {driverList.map((driver) => (
                            <option key={driver._id} value={driver._id}>
                              {driver.name} - {driver.mobile}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          onClick={() => setUseNewDriver(true)}
                          style={{
                            padding: "4px 10px",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Driver Name"
                          value={driverName}
                          onChange={(e) => setDriverName(e.target.value)}
                          style={{ padding: "5px", width: "40%" }}
                        />
                        <input
                          type="text"
                          placeholder="Mobile Number"
                          value={driverMobile}
                          onChange={(e) => {
                            const onlyDigits = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setDriverMobile(onlyDigits);
                          }}
                          style={{ padding: "5px", width: "40%" }}
                          maxLength={10}
                        />
                        <button
                          type="button"
                          onClick={() => setUseNewDriver(false)}
                          style={{
                            padding: "4px 10px",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>
                )}

              <button
                onClick={updateOrderStatus}
                style={{
                  marginTop: "5px",
                  padding: "10px 20px",
                  backgroundColor: "#4caf50",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Save
              </button>
            </div>
            <div style={{ marginTop: "10px" }}>
              <h3>Order Status History</h3>
              <table
                style={{
                  width: "50%",
                  borderCollapse: "collapse",
                  backgroundColor: "white",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        padding: "8px",
                        border: "1px solid #ddd",
                        textAlign: "left",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        border: "1px solid #ddd",
                        textAlign: "left",
                      }}
                    >
                      Updated At
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        border: "1px solid #ddd",
                        textAlign: "left",
                      }}
                    >
                      Time Taken
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {statusHistory.length > 0 ? (
                    statusHistory.map((history, index) => {
                      let timeSpent = "--";
                      if (index > 0) {
                        const current = new Date(history.createdAt);
                        const previous = new Date(
                          statusHistory[index - 1].createdAt
                        );
                        const diffMs = current - previous;
                        const totalSeconds = Math.floor(diffMs / 1000);
                        const hours = Math.floor(totalSeconds / 3600);
                        const minutes = Math.floor((totalSeconds % 3600) / 60);
                        const seconds = totalSeconds % 60;
                        timeSpent = `${hours}h ${minutes}m ${seconds}s`;
                      }

                      const formattedUpdatedAt = new Date(
                        history.updatedAt
                      ).toLocaleString();

                      return (
                        <tr key={history._id}>
                          <td
                            style={{ padding: "8px", border: "1px solid #ddd" }}
                          >
                            {history.status.charAt(0).toUpperCase() +
                              history.status.slice(1)}
                          </td>
                          <td
                            style={{ padding: "8px", border: "1px solid #ddd" }}
                          >
                            {formattedUpdatedAt}
                          </td>
                          <td
                            style={{ padding: "8px", border: "1px solid #ddd" }}
                          >
                            {timeSpent}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ padding: "8px", textAlign: "center" }}
                      >
                        No status history available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/*<h3>Payment Details</h3>
      <button
    style={{
     
      padding: "10px 20px",
      backgroundColor: "#4caf50",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
    }}
    onClick={() => {
     
      alert("");
    }}
  >
    Payment
  </button>
*/}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div>
            <h1>Order Details</h1>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "15px",
              }}
            >
              <div
                onClick={() => setSelectedSort("pending")}
                style={statusBlockStyle("pending")}
              >
                Pending ({getCountByStatus("pending")})
              </div>
              <div
                onClick={() => setSelectedSort("accept")}
                style={statusBlockStyle("accept")}
              >
                Accept ({getCountByStatus("accept")})
              </div>
              <div
                onClick={() => setSelectedSort("ready for delivery")}
                style={statusBlockStyle("ready for delivery")}
              >
                Ready for Delivery ({getCountByStatus("ready for delivery")})
              </div>
              <div
                onClick={() => setSelectedSort("delivery pickup")}
                style={statusBlockStyle("delivery pickup")}
              >
                Delivery Pickup ({getCountByStatus("delivery pickup")})
              </div>
              <div
                onClick={() => setSelectedSort("out for delivery")}
                style={statusBlockStyle("out for delivery")}
              >
                Out for Delivery ({getCountByStatus("out for delivery")})
              </div>
              <div
                onClick={() => setSelectedSort("completed")}
                style={statusBlockStyle("completed")}
              >
                Completed ({getCountByStatus("completed")})
              </div>
            </div>

            {/* <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="text"
                placeholder="Search orders..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "20%",
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "16px",
                  marginRight: "20px",
                }}
              /> */}
            {/*<select
    style={{ padding: "6px" }}
    value={selectedSort}
    onChange={(e) => setSelectedSort(e.target.value)}
  >
    <option value="">All</option>
    <option value="pending">Pending</option>
    <option value="accept">Accept</option>
    <option value="ready for delivery">Ready for Delivery</option>
    <option value="delivery pickup">Delivery Pickup</option>
    <option value="out for delivery">Out for Delivery</option>
    <option value="completed">Completed</option>
  </select>*/}
            {/* </div> */}

            <div style={{ marginTop: "10px" }}>
              <input
                type="text"
                placeholder="Search "
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  marginBottom: "10px",
                  padding: "8px",
                  width: "100%",
                  maxWidth: "200px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />

              <div
              // style={{
              //   height: "500px",
              //   border: "1px solid #ddd",
              //   borderRadius: "4px",
              //   overflow: "overflow",
              // }}
              >
                <DataTable
                  value={filteredOrders}
                  scrollable
                  scrollHeight="450px"
                  stripedRows
                  paginator
                  className="datatable-scrollable"
                  rows={10}
                  emptyMessage="No orders found."
                  selectionMode="single"
                  onRowClick={(e) => {
                    setSelectedOrder(e.data);
                    setNewStatus(e.data.status);
                    setRows(e.data.products || []);
                  }}
                >
                  <Column
                    field="orderId"
                    header="Order ID"
                    body={responsiveColumnHeader("Order ID", "orderId", orderIdTemplate)}
                  // style={{ minWidth: "150px" }}
                  />
                  <Column
                    field="phoneNumber"
                    header="Phone Number"
                    body={responsiveColumnHeader("Phone Number", "phoneNumber")}
                  // style={{ minWidth: "150px", textAlign: "center" }}
                  />
                  <Column
                    header="Product Details"
                    body={responsiveColumnHeader("Product Details", null, productsTemplate)}
                  // style={{ minWidth: "250px", whiteSpace: "pre-wrap" }}
                  />
                  <Column
                    field="amount"
                    header="Total Price"
                    body={responsiveColumnHeader("Total Price", "amount", (rowData) => formatCurrency(rowData.amount))}
                  // style={{ minWidth: "120px" }}
                  />

                  <Column
                    header="Delivery"
                    body={responsiveColumnHeader("Delivery", null, driverTemplate)}
                  // style={{ minWidth: "150px" }}
                  />
                  <Column
                    field="status"
                    header="Status"
                    body={responsiveColumnHeader("Status", "status")}
                  // style={{ minWidth: "150px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderDetails;